/**
 *  ProgressBar script file
 **/

export default {
  name: 'ProgressBar',
  mixins: [],
  components: {},
  props: {
    title: {
      type: String,
      required: false
    },
    total: {
      type: [String, Number],
      default: 0,
      required: true
    },
    current: {
      type: [String, Number],
      default: 0,
      required: true
    },
    color: {
      type: String,
      default: '#00edff',
      required: false
    },
    bgColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.16)',
      required: false
    },
    format: {
      type: Function,
      default: n => n,
      required: false
    }
  },

  data () {
    return {}
  },
  computed: {
    calculateWidth () {
      if (this.total === 0) {
        return '0%'
      }

      return `${(this.current / this.total) * 100}%`
    }
  },
  methods: {}
}
